<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import router from "@/router";

  export default {
    name: 'App',
    mounted() {

    }
  }
</script>

<style>

  #app {
    font-family: Microsoft YaHei UI, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
  }

  body {
    margin: 0;
  }

  .form_table_cls {
    height: calc(100vh - 260px);
    overflow: hidden;
    overflow-y: auto;
  }

  .hide /deep/ .el-upload--picture-card {
    display: none;
  }

  ::-webkit-scrollbar {
   width: 9px !important;
   height: 9px !important;
  }

  /* !*定义滚动条轨道 内阴影+圆角*! */
  ::-webkit-scrollbar-track {
   border-radius: 10px !important;
   background-color: rgba(0, 0, 0, 0.1);
  }

  /* !*定义滑块 内阴影+圆角*! */
  ::-webkit-scrollbar-thumb {
   border-radius: 10px !important;
   /* -webkit-box-shadow: inset 0 0 6px rgba(5, 5, 5, 0.3); */
   background-color: rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue